export function getQueryKey(providerType, fileType) {
    var queryKey = ['RecommendedData', providerType];
    if (fileType) {
        queryKey.push(fileType);
    }
    return queryKey;
}
//# sourceMappingURL=getQueryKey.js.map